/* eslint-disable dot-notation */
import React from 'react';
import { DefaultUploadImages } from '../defaults';
import { IUploadImagesFormFields } from '../types';

const getDefaultValues = (apiDefaultValues: Object): IUploadImagesFormFields => ({
    androidAppLogoHDPIPortrait: apiDefaultValues['Android_hdpi_Logo'] ?? DefaultUploadImages.AppLogo,
    androidAppIconHDPIPortrait: apiDefaultValues['Android_hdpi_Icon'] ?? DefaultUploadImages.AppIcon,
    androidAppLogoXHDPIPortrait: apiDefaultValues['Android_xhdpi_Logo'] ?? DefaultUploadImages.AppLogo,
    androidAppIconXHDPIPortrait: apiDefaultValues['Android_xhdpi_Icon'] ?? DefaultUploadImages.AppIcon,
    androidAppIconXXHDPIPortrait: apiDefaultValues['Android_xxhdpi_Icon'] ?? DefaultUploadImages.AppIcon,
    androidSplashScreenHDPIPortrait: apiDefaultValues['Android_hdpi_Background'] ?? DefaultUploadImages.SplashScreenPortraitHDPI,
    androidSplashScreenXHDPIPortrait: apiDefaultValues['Android_xhdpi_Background'] ?? DefaultUploadImages.SplashScreenPortraitXHDPI,
    androidSplashScreenXXHDPIPortrait: apiDefaultValues['Android_xxhdpi_Background'] ?? DefaultUploadImages.SplashScreenPortraitXXHDPI,
    iOS_AppDefaultIcon: apiDefaultValues['iOS_AppDefaultIcon'] ?? DefaultUploadImages.AppIcon,
    iOS_SplashScreeniphone: apiDefaultValues['iOS_SplashScreeniphone'] ?? DefaultUploadImages.SplashScreenPortrait,
    iOS_AppApplicationLogo: apiDefaultValues['iOS_AppApplicationLogo'] ?? DefaultUploadImages.AppIcon
});

// iosAppIconiphone: apiDefaultValues['iOS_Icon-iPhone@2x'] ?? DefaultUploadImages.AppIcon,
// iosAppIconipad: apiDefaultValues['iOS_Icon_iPad'] ?? DefaultUploadImages.AppIcon,
// iosSplashScreenipad: apiDefaultValues['iOS_SplashScreen_iPad'] ?? DefaultUploadImages.SplashScreenPortrait,
export const useUploadImageDefaultValues = (imageData: { name: string; imageUrl: string; }[]) => {
    const apiDefaultValues = (imageData.reduce((acc, curr) => {
        acc[curr.name] = curr.imageUrl;
        return acc;
    }, {}));

    return React.useMemo(() => getDefaultValues(apiDefaultValues), [apiDefaultValues]);
};
